//medidad Banner 650x360px
export const ultimasNoticias = [
  {
        "imagen" :"../assets/imgs/Convocatorias/2026/Cursos de Verano.jpeg",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/15.- Convocatoria cursos de verano .pdf",
        "titulo" : "Curso de Verano Cultural 2026",
        "fecha" : "del 02 de julio al 15 de julio del 2026",
        "categoria" : "Convocatoria"
    },
  {
        "imagen" :"../assets/imgs/Convocatorias/2026/PV_Arte + Educación_FB.jpg.jpeg",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/14.-Convocatoria - Arte Educación.pdf",
        "titulo" : "Arte + Educación: Conceptos y prácticas para la construcción de agentes de cambio Modalidad semipresencial",
        "fecha" : "del 19 de junio al 12 de julio del 2026",
        "categoria" : "Convocatoria"
    },
   {
        "imagen" :"../assets/imgs/Convocatorias/2026/Programa de Apoyos.jpeg",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/CECULTA/dir5/2026/Convocatorias/13.-Convocatoria Fortalecimiento Actividades Artísticas y Culturales 2026.pdf",
        "titulo" : "Programa de Apoyos para el Fortalecimiento de Actividades Artísticas y Culturales del Ejercicio Fiscal 2026",
        "fecha" : "del 15 de junio al 30 de noviembre del 2026",
        "categoria" : "Convocatoria"
    },
   {
        "imagen" :"../assets/imgs/Convocatorias/2026/Transparencia_en_Corto_2026.jpeg",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/contraloriat/dir1/Documentos/TRANSP%20EN%20CORTO_CONVOCATORIA_2026.pdf",
        "titulo" : "XXI edición del Concurso Nacional de Transparencia en Corto ",
        "fecha" : "del 05 de junio al 21 de agosto del 2026",
        "categoria" : "Convocatoria"
    },
      
  
   ]